import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "search_area" }
const _hoisted_2 = { class: "search_content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "search_content_title" }, "数组（匹配首次，支持拼音）", -1)
const _hoisted_4 = ["value"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "search_content" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "search_content_title" }, "文章 (匹配全量，不支持拼音)", -1)
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "search_content_text" }
const _hoisted_10 = ["innerHTML"]

import { reactive } from 'vue';
import XPinyinSearchAndHighlightKeyword, { type IFHighlightSearchConfig, type IFHighlightSearchResult } from '../packages/xPinyinSearchAndHighlightKeyword/src/index';
import { trim, cloneDeep, forEach } from 'lodash-es';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const config: Partial<IFHighlightSearchConfig> = {
  color: '#FFFF00',
  tag: 'font'
}
const hlkIns = new XPinyinSearchAndHighlightKeyword(config);

function getHighlightSearch(str: string, keyword: string): IFHighlightSearchResult {
  return hlkIns.search(str, keyword);
}

function getHighlightKeyword(str: string, keyword: string): string {
  return hlkIns.highlight(str, keyword);
}

const testData = reactive({
  array: [
    {
      key: 'Warriors',
      value: '金州勇士-金州勇士'
    },
    {
      key: 'Lakers',
      value: '洛杉矶湖人'
    },
    {
      key: 'Clippers',
      value: '洛杉矶快船'
    },
    {
      key: 'Kings',
      value: '萨克拉门托国王'
    },
    {
      key: 'Mavericks',
      value: '达拉斯独行侠'
    },
    {
      key: 'Rockets',
      value: '休斯顿火箭'
    },
    {
      key: 'Spurs',
      value: '圣安东尼奥马刺'
    },
    {
      key: 'Grizzlies',
      value: '孟菲斯灰熊'
    },
    {
      key: 'Jazz',
      value: '犹他爵士'
    },
    {
      key: 'Pelicans',
      value: '新奥尔良鹈鹕'
    },
    {
      key: 'Nuggets',
      value: '丹佛掘金'
    },
    {
      key: 'Thunder',
      value: '俄克拉何马雷霆'
    },
    {
      key: 'Timberwolves',
      value: '明尼苏达森林狼'
    },
    {
      key: 'Suns',
      value: '菲尼克斯太阳'
    },
    {
      key: 'Blazers',
      value: '波特兰开拓者'
    },
    {
      key: 'Nets',
      value: '布鲁克林篮网'
    },
    {
      key: 'Knicks',
      value: '纽约尼克斯'
    },
    {
      key: 'Magic',
      value: '奥兰多魔术'
    },
    {
      key: 'Heat',
      value: '迈阿密热火'
    },
    {
      key: '76ers',
      value: '费城76人'
    },
    {
      key: 'Hornets',
      value: '夏洛特黄蜂'
    },
    {
      key: 'Bucks',
      value: '密尔沃基雄鹿'
    },
    {
      key: 'Celtics',
      value: '波士顿凯尔特人'
    },
    {
      key: 'Hawks',
      value: '亚特兰大老鹰'
    },
    {
      key: 'Bulls',
      value: '芝加哥公牛'
    },
    {
      key: 'Cavaliers',
      value: '克利夫兰骑士'
    },
    {
      key: 'Pacers',
      value: '印第安纳步行者'
    },
    {
      key: 'Wizards',
      value: '华盛顿奇才'
    },
    {
      key: 'Pistons',
      value: '底特律活塞'
    },
    {
      key: 'Raptors',
      value: '多伦多猛龙'
    }
  ],
  text: '1898年，美国第一个篮球组织国家篮球联盟（NBL，1898-1904）成立，但当时篮球规则还不完善，组织机构也不健全，经过几个赛季后，该组织就名存实亡了。\n' +
    '\n' +
    '1946年6月6日，全美篮球协会（BAA）成立；1949年8月3日，BAA与国家篮球联盟（NBL）合并，改名“国家篮球协会”（NBA）。\n' +
    '\n' +
    '非白人球员\n' +
    '在成立初期，NBA的球员和教练全部由白人组成。1947年，美籍日裔的三阪亘被纽约尼克斯首轮选中，成为了NBA历史上首位非白人球员，同时他也是第一个加盟NBA的亚裔球员[4]。不过三阪亘在1947-48赛季仅仅为纽约尼克斯队出场三次贡献了七分后就被裁掉了。1950年，波士顿凯尔特人在第二轮选中了来自杜肯大学的黑人球员扎克·库珀（Charles Cooper），这是NBA历史上第一位入选的黑人[5]，同年一起被选中的还有“糖水”纳撒尼尔·克利夫顿（纽约尼克斯队）和厄尔·洛依德（华盛顿首都队），克利福顿在三人当中最先获得了球队合同[6]。1950年10月31日，劳埃德在华盛顿首都队与罗彻斯特皇家队的比赛中登场，黑人球员首次踏上了NBA赛场[7]。尽管当时美国的种族歧视仍然相当严重，不过随着比尔·拉塞尔（Bill Russell）、威尔特·张伯伦（Wilt Chamberlain）等人在球场上不断创造佳绩，黑人球员逐渐被球迷们接受并成为了NBA的主角。进入90年代后，黑人球员在数量上开始超越白人球员。2006-07赛季，黑人球员占NBA所有球员的比率已经达到75%，黑人主教练亦占NBA所有主教练的40%[8]。\n' +
    '\n' +
    '1966年，比尔·拉塞尔成为NBA首位黑人主教练，他作为球员兼教练带领波士顿凯尔特人获得了1968和1969年度的总冠军；而NBA亦成为了第一个拥有黑人主教练的职业体育联盟。NBA的首个黑人总经理和球队老板分别出现在1972年和2002年。\n' +
    '\n' +
    '标志\n' +
    'NBA的标志是由一位纽约平面设计师阿兰·西格尔（Alan Siegel）所设计，并在1969年首次出现在NBA官方的宣传资料上。不过NBA官方没有正式公布过标志的设计者。标志的图案是一名侧身控球的篮球员的剪影；整个标志由红、白、蓝三种颜色构成，这和MLB（美国职业棒球大联盟）的配色一样，西格尔解释说是为了“在两个联盟的标志之间营造一种视觉上的和谐”。很多人认为标志上的人物原型就是前洛杉矶湖人的明星球员杰里·威斯特（Jerry West），而西格尔也曾透露这一消息；不过NBA官方一直拒绝承认，并表示标志上的人物形象是一个“谜团”，因为NBA“没有任何关于标志设计者的确切记录”。[9]\n' +
    '\n' +
    '1940年代：BAA以及NBL\n' +
    '1946年，美国东北部及中西部一些大型体育球馆的老板在纽约商讨成立一个篮球组织的事宜；不过这些球馆的老板对篮球并不是十分的感兴趣，他们原本就拥有冰球队伍，因此老板们最初的目的只是为了使他们的球馆在冰球休赛期间得到更充分的利用。\n' +
    '\n' +
    '1946年6月11日，包括著名的纽约麦迪逊花园广场在内的1家球馆老板们联合成立了全美篮球协会（BAA）。美国冰球联盟（AHL）的主席莫里斯·波杜夫担任了NBA（BAA）的第一任主席[10][11]。\n' +
    '\n' +
    '1946年11月1日，NBA（BAA）历史上的第一场正式比赛在加拿大多伦多的枫叶花园球场举行，由多伦多爱斯基摩人主场迎战纽约尼克斯，共有7,090名观众涌入球馆观看了这场赛事，结果纽约以68-66取得了胜利[10]。费城勇士获得了第一个NBA（BAA）总冠军。当时BAA的竞争对手有“美国篮球联盟”（ABL）、“国家篮球联盟”（NBL）等，BAA最先尝试了在大城市的大球馆进行比赛。\n' +
    '\n' +
    '1949年8月3日，BAA同意与当时的竞争对手、主要位于中西部的国家篮球联盟（NBL）合并，组成了一个拥有17支球队的大联盟，并命名为“国家篮球协会”（NBA）[12]。不过新协会成立的第二个赛季，球队数量就缩减到11支；随着小球队的相继倒闭，1954年NBA只剩了下8支球队。这8支球队也一直保留到现在（亚特兰大老鹰、波士顿凯尔特人、底特律活塞、金州勇士，洛杉矶湖人、纽约尼克斯、费城76人以及萨克拉门托国王），当然很多球队的主场已经变迁，为了更好的发展，那些深处偏僻小城的球队都相继搬到了大城市。譬如老鹰队由三城先后迁往密尔沃基、圣路易斯和亚特兰大，活塞队则从韦恩堡搬到底特律，湖人由明尼阿波利斯迁徙到洛杉矶，国王队从罗彻斯特先后移至辛辛那提和萨克拉门托。在1961-62赛季芝加哥包装工人队加入联盟之前，NBA一直由这8支球队来维持场面。并且在1967-68赛季之前，NBA球队数量一直停留在10支以下。\n' +
    '\n' +
    '1950年代：24秒钟装置投入使用，湖人王朝，凯尔特人王朝\n' +
    '\n' +
    '1950年代囊括4座总冠军的明尼阿波利斯湖人\n' +
    '为了鼓励进攻，1954年NBA迎来了第一次历史性的改革:24秒钟装置。当时由于比赛中没有进攻时间限制，控球一方往往都不轻易投篮以免失去进攻机会，防守一方唯有采用犯规来夺回控球权，因此比赛基本都是在罚球线上度过的，不仅节奏缓慢，得分也很低。为了改变这种状况，使比赛节奏加快并流畅，条例规定，如果控球一方在24秒内未能把球接触到篮筐将会被判违例并失去控球权。NBA除了制定了24秒进攻时间的新规则外，同时还将球队单节犯规次数限制为6次。改革的效果是明显的，实行24秒新规则的第一个赛季，NBA球队的平均得分达到了93.1分，比前个赛季多了13.6分，波士顿凯尔特人更成为了首支赛季平均得分过百的球队[13]。\n' +
    '\n' +
    '50年代初，在中锋乔治·迈肯的带领下，明尼阿波利斯湖人在1949到1954六年间五次夺得总冠军，缔造了NBA历史上第一个湖人王朝。1955-56赛季，波士顿凯尔特人得到了新秀中锋比尔·拉塞尔，在跑轰传奇教练阿诺·奥尔巴赫的带领下，波士顿凯尔特人拿到了接下来13年中11个总冠军，包括1959到1966年的八连霸。比尔·拉塞尔一生最伟大的对手威尔特·张伯伦也在1959年加入到NBA，与比尔·拉塞尔疯狂的夺冠记录不同，张伯伦最闪耀的是他的个人数据，包括单场最高分（100分），单场最高篮板（55个）都由他来保持。联盟生态方面 ，常规赛表现东部赛区总体比西部赛区略强，总冠军则是五五波。\n' +
    '\n' +
    '1953-54赛季，电视台首次转播NBA赛事，当时的杜蒙特电视台与NBA签订了一份39,000美元的合同，在当个赛季播出了13场NBA比赛。\n' +
    '\n' +
    '1960年代：联盟扩张、ABA的挑战\n' +
    '\n' +
    '1960年代囊括9座总冠军的波士顿凯尔特人\n' +
    '1960年，湖人队从明尼阿波利斯迁到洛杉矶，成为NBA首支西部球队，此后费城勇士（现金州勇士）、锡拉丘兹民族（现费城76人）、圣路易老鹰（现亚特兰大老鹰队）亦分别迁居。芝加哥包装工（现华盛顿奇才）于1961加入，成为第9支NBA球队。1966-68年间又增加了5队，分别为芝加哥公牛、西雅图超音速（现俄克拉何马雷霆）、圣迭戈火箭（现休斯敦火箭）、密尔沃基雄鹿及菲尼克斯太阳。1967年，NBA受到了“美国篮球协会”（ABA，1967-1976）的强力挑战。1967年成立的ABA采用非传统的红、白、蓝三色球，设立三分线，使用30秒的进攻时间；这个新兴的职业联盟更强调进攻，以开放性以及自由度来吸引球迷和球星。而ABA的开放性、娱乐性以及自由度是当时NBA无法相比的。由于当时NBA不允许球员未毕业的大学球员直接进入联盟，不少极具天赋的年轻人选择了ABA。NBA则更注重大学里的新星，传奇中锋“天勾”卡里姆·阿卜杜勒-贾巴尔（Kareem Abdul-Jabbar）在1969年加入联盟。联盟生态方面则是明显东强西弱，包括60年代全部的冠军都由东部包办。\n' +
    '\n' +
    '\n' +
    '1966年，波士顿凯尔特人的比尔·拉塞尔与费城76人的威尔特·张伯伦\n' +
    '1962-63赛季起，美国广播公司（ABC）成为了NBA的主要电视合作伙伴。\n' +
    '\n' +
    '1970年代：兼并ABA\n' +
    '尽管“美国篮球协会”（ABA）吸引了包括“J博士”朱利叶斯·欧文这样的天才球星，不过由于得不到电视转播的支持以及本身财政出现问题，ABA于1976年破产[14][15]。\n' +
    '\n' +
    '1970年，首次向全美观众完整直播了总决赛。\n' +
    '\n' +
    '1976年，NBA接纳了4支ABA球队印第安那步行者，圣安东尼奥马刺，纽约篮网（后改名新泽西篮网、布鲁克林篮网）以及丹佛火箭（由于火箭名称已为休斯敦使用，故改名丹佛掘金）后，联盟球队达到了22支。\n' +
    '\n' +
    'ABA的一些规则后来也被NBA接纳和采用： 1979-80赛季NBA首次设立三分线，目前三分线顶弧距离篮筐23英尺9英寸(7.24米)，边线距离篮筐22英尺(6.71米)。 1983-84赛季又开始举办最先由ABA开创的扣篮大赛。\n' +
    '\n' +
    '1980年代：大鸟VS魔术师\n' +
    '这时的西部在经过十几年的时间，终于慢慢强于东部。\n' +
    '\n' +
    '1979年，两个未来巨星拉里·伯德（Larry Bird）和魔术师约翰逊（Magic Johnson）分别加盟波士顿凯尔特人和洛杉矶湖人。\n' +
    '\n' +
    '拉里·伯德带领波士顿凯尔特人5次杀入总决赛3次夺冠，魔术师约翰逊联同卡里姆·阿卜杜勒-贾巴尔将洛杉矶湖人9次送进总决赛并捧得5次奖杯。这时东部因波士顿凯尔特人、费城76人、底特律活塞、密瓦尔基雄鹿等强队，总体实力是略高于包含洛杉矶湖人的西部，他们两个共同缔造NBA的80年代辉煌时代。\n' +
    '\n' +
    '1984年，又一个超级巨星进入联盟，他就是迈克尔·乔丹（Michael Jordan）。乔丹在90年代两次率领芝加哥公牛完成3连霸。\n' +
    '\n' +
    '自1980年起，随着达拉斯独行侠、夏洛特黄蜂、迈阿密热火、明尼苏达森林狼、奥兰多魔术等球队相继加入，至1989-90赛季，NBA已经增加到27支球队。\n' +
    '\n' +
    '1990年代：全球化，WNBA创立\n' +
    '进入90年代，NBA开始迈向国际化。1992年巴塞罗那奥运会，美国篮协首次派出由NBA球星组成的梦之队参赛，包括迈克尔·乔丹、拉里·伯德、魔术师约翰逊等明星。并以平均每场胜出44分的巨大优势获得了冠军[16]，这支由NBA顶级球星组成的梦之队让世界认识到了NBA的魅力。\n' +
    '\n' +
    '这时东部西部实力虽然各有千秋，不过东部可有由迈克尔·乔丹所领军的超级强队公牛，在91-93球季拿下三连冠，夸张的是，乔丹跑去打棒球之后复出，又在96-98这三年拿下三连霸，并创下当时NBA最高的72胜10负，其他东部强队只能感叹生不逢时。这纪录一直到2015-16年的金州勇士队创下73胜9负，才将之改写。\n' +
    '\n' +
    '为获得更多的商业利益，NBA把部分季前赛甚至常规赛安排在欧洲、亚太以及墨西哥等地举行，这些比赛亦称为NBA海外赛；1990-91赛季，NBA把菲尼克斯太阳与犹他爵士的两场常规赛的比赛场地安排在日本东京，这是NBA正式赛事首次在非美国及加拿大本地举行。同时全世界对NBA的关注随着电视转播而扩大，2006-07赛季，全球共有215个国家41种语言188家电视台转播NBA赛事或制作NBA相关节目[17]。\n' +
    '\n' +
    '随着NBA的影响扩大，越来越多的来自世界各地的球星纷纷加入到NBA。近年来，NBA为了吸引更多来自世界各地的优秀球员，将国际球员的限制逐渐放宽；原先国际球员一般都是先进入NCAA篮球联赛才能参加NBA选秀，现在已经可以直接参选了，NBA球探都亲自到各国联赛去挖掘有潜力的新星。很多国际球星在NBA闯出了名堂，例如来自尼日利亚的中锋1994年MVP阿基姆·奥拉朱旺（Hakeem Olajuwon）带领休斯敦火箭两次问鼎NBA总冠军，德国球星德克·诺维茨基（Dirk Nowitzki）把达拉斯独行侠带进2006年NBA总决赛并获得了2007年MVP以及2011年总冠军及FMVP，还有连续当选2005年和2006年MVP的加拿大控卫史蒂夫·纳什（Steve Nash），四次荣获最佳防守球员的萨伊中锋迪肯贝·穆托姆博（Dikembe Mutombo）等等。2006-07赛季NBA的国际球员达到60名，他们来自28个不同的国家[18]。\n' +
    '\n' +
    '1995年，多伦多猛龙与温哥华灰熊加入NBA，使得NBA的版图再次扩展至美国本土之外。\n' +
    '\n' +
    '1996年，NBA创办了国家女子篮球协会（WNBA）。\n' +
    '\n' +
    '1999年，NBA开办了自己的电视频道NBA-TV。\n' +
    '\n' +
    '2001年，NBA又创立了国家篮球协会发展联盟，即现在的NBA G联盟（G-League）。\n' +
    '\n' +
    '1990年代末：第一次封馆危机\n' +
    '1990年代末也爆发了一场劳资纠纷。1998年由于赛前劳资谈判彻底失败，劳方和资方拒绝任何往来，因此NBA进入全面性封馆。在205天后，劳资双方靠着多方面牵线进行许多密集会议，直到1999年1月25日劳资双方达成十年收益分配协议，1998-99赛季推迟到1999年2月5日才开始，当年的常规赛也由82场压缩到50场。圣安东尼奥马刺在该年夺下封馆后的NBA总冠军。\n' +
    '\n' +
    '第30支球队，新球试用\n' +
    '2004-05赛季，随着夏洛特山猫的加入，NBA球队达到了30支。\n' +
    '\n' +
    '在千禧年之后，很明显地变成了西强东弱的局面，举例来说09-10年的赛季，高达50胜的俄克拉何马雷霆竟然只能以老八之姿进入季后赛。由三巨头GDP马努·吉诺比利（Manu Ginóbili）、托尼·帕克（Tony Parker）、蒂姆·邓肯（Tim Duncan）的圣安东尼奥马刺，禅师菲尔·杰克逊、科比·布莱恩特、沙奎尔·奥尼尔的湖人，跟德克·诺维茨基所领军的达拉斯独行侠，中国状元姚明、特雷西·麦格雷迪领军的休斯敦火箭队则是在近代西部列强中较为人所知。\n' +
    '\n' +
    '2006年6月29日，NBA官方介绍了将在2006-07赛季投入使用的新球。这也是NBA35年来首次更换比赛用球，在NBA60年历史中也仅仅是第二次。由斯伯丁公司负责设计生产的新球使用新的合成纤维材料，他们称新球可以让球员抓的更紧，更有球感。事实上，很多球员对新球并不好感，抱怨新球干的时候太黏手，沾到汗水却又太滑。于是NBA官方不得不在2007年1月1日重新使用皮革制球。2006年，由于锐跑被阿迪达斯所并购，所以NBA的球衣供应商也由原本合作多年的锐跑改换为阿迪达斯。\n' +
    '\n' +
    '第二次封馆危机：联盟停摆\n' +
    '由于1999年制订十年劳资收益分配已到期，即将进行劳资谈判2011年7月1日，NBA执行长大卫·斯特恩（David Stern）再次宣布NBA进入封馆，其原因主要为球团认为球员工资飙升，使得球团无利可图，甚至造成联盟总亏损加倍，双方在劳资谈判过程中意见严重分歧，导致无法达成共识，进而导致NBA联盟第二次封馆的命运。\n' +
    '\n' +
    '2011年8月10日，进行第二场劳资会议，但由于资方和劳方又无法达成共识，其主要原因为资方提高球团豪华税、球员奢侈税的税收，球员工会拒绝再提高其他不必要税收，因此NBA执行长David Stern再次宣布取消季前热身赛两周，导致第二场会议不欢而散。\n' +
    '\n' +
    '2011年9月20日，进行第三场劳资会议，有15位NBA现役球员参与这次劳资谈判中，球员工会目的在于描述球员主观和客观的想法和意见，为争取球员最大权益，但是不为资方所理解，由于资方对于电视转播权益金和收益比例无法达成共识，且各球团老板各有分歧意见，球团工会全体气愤而退席，NBA执行长大卫·斯特恩再次宣布取消季前所有热身赛和常规赛10月~11月的赛程。\n' +
    '\n' +
    '2011年10月12日，球员工会召开商业会议，有部分球员提议另组新NBA联盟和解散球员公会，诉诸法律运动裁决法庭审判。\n' +
    '\n' +
    '2011年10月31日，进行第四场劳资会议，虽然双方以谈定电视转播权利金和收益比例，但最主要工资分配始终无法达成协定，资方的理想收益与劳方的理想收益相差甚多，球员工会坚持要占收益52.5％比例，但是资方坚持占50.5％比例为底限，最后分歧意见过大，NBA执行长大卫·斯特恩决定取消常规赛一半以上的赛程，球员工会则是决定解散公会，也已经向美国劳动仲裁机构提交诉讼。\n' +
    '\n' +
    '2011年11月26日，经过25天的劳资互不往来。于26日进行第五场劳资会议，再度聚集纽约集会，结果在超过15小时的协商后，双方终于达成初步协议。NBA执行长大卫·斯特恩表示：“新版劳资协议的产生，对于新球季在12月25日开打感到乐观”，2011-12年球季各队约有66场常规赛。\n' +
    '\n' +
    '联盟新气息\n' +
    '2011年11月30日，新版劳资协议达成，NBA联盟正式公开，球员工会确定同意，常规赛于12月25日圣诞节正式开打。\n' +
    '\n' +
    '2016年4月16日，NBA总裁萧华宣布自2017-18年球季起，联盟将开放各队在球衣左上方印上赞助商广告。这将是北美四大职业运动，首个正规赛球衣广告创举。球衣补丁计划目前仍有些许问题需要解决，例如球星代言冲突，此计划将进行三个球季，再对球迷反应与实际成效进行检讨。另外，贩售球衣部分，球团可自行选择，有广告赞助或无广告标志商品，卖给球迷。\n' +
    '\n' +
    '2017年9月24日，自1985年起，每年NBA总冠军会接受总统会见，该传统在2017年被打破[19]。2017年冠军金州勇士内部就是否前往白宫产生分歧，而特朗普推特上宣布"由于库里犹豫不决，所以取消邀请金州勇士前往白宫"。特朗普撤销邀请引发大量NBA球员抨击，NBA联盟总裁席佛也对此表示对此事件感到遗憾。NBA球员工会表达尊重双方意见，表示对此事件感到惋惜。\n' +
    '\n' +
    '2018年8月24日，NBA官方向各队球团与球团负责人与球团总经理与球团现任教练团提出一份备忘录，上面提到联盟将针对3项规则做出修改，进攻方在抢到进攻篮板后的进攻时间从原本的24秒缩短为14秒、简化快攻蓄意犯规的规则定义、扩大对恶意行为的定义（包括球员恶意语言谩骂），NBA赛事委员会将会在9月下旬召开会议以针对这3项规则进行投票，只要通过三分之二的门槛，新规则就将于新赛季正式施行，并且先NBA G联盟（NBA G League）测试。NBA球员工会也对NBA联盟联盟这三项规则修改提议表示尊重与关切。\n' +
    '\n' +
    '2020年3月12日，由于犹他爵士队中锋鲁迪·戈贝尔（Rudy Gobert）确诊新型冠状病毒（Covid-19），联盟宣布无限期停赛。6月4日，NBA联盟董事会正式通过22支球队复赛的提议，2019-20赛季剩余赛事于7月31日在奥兰多的迪士尼世界重启，称为NBA泡泡。达米姆·利拉德获得种子赛MVP奖项。在总决赛中，洛杉矶湖人队以4比2的比分战胜了迈阿密热火队。\n' +
    '\n' +
    '2020-21赛季，本赛季首次引进分区7-10名进行附加赛决定7和8种子。而西部的曼菲斯灰熊也成为历史上第一支以分区第9名拿到季后赛门票的球队。\n' +
    '\n' +
    '2021-22赛季，是NBA的第76个赛季，NBA官方评选出了75大球星。\n' +
    '\n' +
    '球队\n' +
    'Map of USA and Canada, NBA, zoom.svg\n' +
    '\n' +
    '波特兰开拓者犹他爵士丹佛掘金俄克拉何马雷霆明尼苏达森林狼洛杉矶快船洛杉矶湖人菲尼克斯太阳萨克拉门托国王金州勇士达拉斯独行侠休斯敦火箭圣安东尼奥马刺新奥尔良鹈鹕孟菲斯灰熊密尔沃基雄鹿芝加哥公牛印第安纳步行者克利夫兰骑士底特律活塞多伦多猛龙波士顿凯尔特人纽约尼克斯布鲁克林篮网费城76人华盛顿奇才夏洛特黄蜂迈阿密热火奥兰多魔术亚特兰大老鹰\n' +
    'NBA由成立之初的11队发展到现在的30队，当中经历了许多新球队的建立，老球队的变迁或是倒闭。70年历史中波士顿凯尔特人及洛杉矶湖人是最成功的球队，他们一共各获得了17个NBA总冠军。2012年最值钱的球队是洛杉矶湖人，市值9亿美元。2014年，微软前执行长鲍尔默将以20亿美元（约台币600亿元）天价买下快船，也写下NBA球队转手价格新纪录。[20]\n' +
    '\n' +
    '现在NBA球队多数是以球队所在城市名称作为球队名，部分以州份名称作为球队名的球队有明尼苏达森林狼、犹他爵士、印第安纳步行者和金州勇士（使用了加利福尼亚州的别名金州）；而布鲁克林篮网队是唯一使用区名的队伍，其队名来自纽约市布鲁克林区。目前洛杉矶、纽约两城市各拥有两只球队。\n' +
    '\n' +
    'NBA目前采用的是2004-05赛季划分的区域，分为东西2个联盟，每个联盟各有3个赛区，每个赛区各有5队。\n' +
    '\n' +
    '赛区\t球队\t所在城市(区域)\t球馆(主场)\t建立时间\t加入时间\n' +
    '东部联盟\n' +
    '大西洋赛区\t波士顿凯尔特人\n' +
    'Boston Celtics\t麻塞诸塞州波士顿\n' +
    'Boston, Massachusetts\tTD花园\n' +
    'TD Garden\t1946年\n' +
    '布鲁克林篮网\n' +
    'Brooklyn Nets\t纽约州纽约市布鲁克林区\n' +
    'Brooklyn, New York\t巴克莱中心\n' +
    'Barclays Center\t1967年*\t1976年\n' +
    '纽约尼克斯\n' +
    'New York Knicks\t纽约州纽约市曼哈顿区\n' +
    'Manhattan, New York\t麦迪逊广场花园\n' +
    'Madison Square Garden\t1946年\n' +
    '费城76人\n' +
    'Philadelphia 76ers\t宾夕法尼亚州费城\n' +
    'Philadelphia, Pennsylvania\t富国银行中心\n' +
    'Wells Fargo Center\t1946年*\t1949年\n' +
    '多伦多猛龙\n' +
    'Toronto Raptors\t安大略省多伦多\n' +
    'Toronto, Ontario\t丰业银行体育馆\n' +
    'Scotiabank Arena[21]\t1995年\n' +
    '中部赛区\t芝加哥公牛\n' +
    'Chicago Bulls\t伊利诺伊州芝加哥\n' +
    'Chicago, Illinois\t联合中心\n' +
    'United Center\t1966年\n' +
    '克利夫兰骑士\n' +
    'Cleveland Cavaliers\t俄亥俄州克利夫兰\n' +
    'Cleveland, Ohio\t速贷竞技馆\n' +
    'Quicken Loans Arena\t1970年\n' +
    '底特律活塞\n' +
    'Detroit Pistons\t密歇根州底特律\n' +
    'Detroit, Michigan\t小凯萨体育馆\n' +
    'Little Caesars Arena\t1941年*\t1948年\n' +
    '印第安纳步行者\n' +
    'Indiana Pacers\t印第安纳州印第安纳波利斯\n' +
    'Indianapolis, Indiana\t班克斯人寿球馆\n' +
    'Bankers Life Fieldhouse\t1967年\t1976年\n' +
    '密尔沃基雄鹿\n' +
    'Milwaukee Bucks\t威斯康星州密尔沃基\n' +
    'Milwaukee, Wisconsin\t第一服务广场\n' +
    'Fiserv Forum\t1968年\n' +
    '东南赛区\t亚特兰大老鹰\n' +
    'Atlanta Hawks\t佐治亚州亚特兰大\n' +
    'Atlanta, Georgia\t州立农业球馆\n' +
    'State Farm Arena[22]\t1946年*\t1949年\n' +
    '夏洛特黄蜂\n' +
    'Charlotte Hornets\t北卡罗来纳州夏洛特\n' +
    'Charlotte, North Carolina\t光谱中心\n' +
    'Spectrum Center[23]\t2004年*\n' +
    '迈阿密热火\n' +
    'Miami Heat\t佛罗里达州迈阿密\n' +
    'Miami, Florida\tFTX球场\n' +
    'FTX Arena[24]\t1988年\n' +
    '奥兰多魔术\n' +
    'Orlando Magic\t佛罗里达州奥兰多\n' +
    'Orlando, Florida\t安丽中心\n' +
    'Amway Center\t1989年\n' +
    '华盛顿奇才\n' +
    'Washington Wizards\t华盛顿哥伦比亚特区\n' +
    'Washington, D.C.\t第一资本竞技馆\n' +
    'Capital One Arena[25]\t1961年*\n' +
    '西部联盟\n' +
    '西北赛区\t丹佛掘金\n' +
    'Denver Nuggets\t科罗拉多州丹佛\n' +
    'Denver, Colorado\t鲍尔体育馆\n' +
    'Ball Arena[26]\t1967年\t1976年\n' +
    '明尼苏达森林狼\n' +
    'Minnesota Timberwolves\t明尼苏达州明尼阿波利斯\n' +
    'Minneapolis, Minnesota\t标靶中心\n' +
    'Target Center\t1989年\n' +
    '俄克拉何马城雷霆\n' +
    'Oklahoma City Thunder\t俄克拉荷马州俄克拉荷马城\n' +
    'Oklahoma City, Oklahoma\t契萨皮克能源公司球场\n' +
    'Chesapeake Energy Arena[27]\t1974年*\n' +
    '波特兰开拓者\n' +
    'Portland Trail Blazers\t俄勒冈州波特兰\n' +
    'Portland, Oregon\t摩达中心\n' +
    'Moda Center[28]\t1970年\n' +
    '犹他爵士\n' +
    'Utah Jazz\t犹他州盐湖城\n' +
    'Salt Lake City, Utah\t能源方案球馆\n' +
    'Vivint Smart Home Arena[29]\t1974年*\n' +
    '太平洋赛区\t金州勇士\n' +
    'Golden State Warriors\t加利福尼亚州旧金山\n' +
    'San Francisco, California\t大通银行中心\n' +
    'Chase Center\t1946年*\n' +
    '洛杉矶快船\n' +
    'Los Angeles Clippers\t加利福尼亚州洛杉矶\n' +
    'Los Angeles, California\t加密货币网体育馆\n' +
    'Crypto.com Arena\t1970年*\n' +
    '洛杉矶湖人\n' +
    'Los Angeles Lakers\t1947年*\t1948年\n' +
    '菲尼克斯太阳\n' +
    'Phoenix Suns\t亚利桑那州菲尼克斯\n' +
    'Phoenix, Arizona\t足迹中心\n' +
    'Footprint Center[30]\t1968年\n' +
    '萨克拉门托国王\n' +
    'Sacramento Kings\t加利福尼亚州萨克拉门托\n' +
    'Sacramento, California\t金州第一中心\n' +
    'Golden 1 Center\t1923年*\t1948年\n' +
    '西南赛区\t达拉斯独行侠\n' +
    'Dallas Mavericks\t得克萨斯州达拉斯\n' +
    'Dallas, Texas\t美国航空中心\n' +
    'American Airlines Center\t1980年\n' +
    '休斯敦火箭\n' +
    'Houston Rockets\t得克萨斯州休斯敦\n' +
    'Houston, Texas\t丰田中心\n' +
    'Toyota Center\t1967年*\n' +
    '孟菲斯灰熊\n' +
    'Memphis Grizzlies\t田纳西州孟菲斯\n' +
    'Memphis, Tennessee\t联邦快递广场\n' +
    'FedExForum\t1995年*\n' +
    '新奥尔良鹈鹕\n' +
    'New Orleans Pelicans\t路易斯安那州新奥尔良\n' +
    'New Orleans, Louisiana\t冰沙国王中心\n' +
    'Smoothie King Center[31]\t1988年*\n' +
    '圣安东尼奥马刺\n' +
    'San Antonio Spurs\t得克萨斯州圣安东尼奥\n' +
    'San Antonio, Texas\tAT&T中心\n' +
    'AT&T Center[32]\t1967年*\t1976年\n' +
    '曾经更名的球队\n' +
    '底特律活塞（前韦恩堡活塞），洛杉矶湖人（前明尼阿波利斯湖人），萨克拉门托国王（前罗彻斯特皇家）1948年由国家篮球联赛加盟BAA（NBA）。\n' +
    '费城76人（前锡拉丘兹民族），亚特兰大老鹰（前三城黑鹰）在1949年BAA和NBL合并的时候由NBL并入。\n' +
    '俄克拉何马城雷霆前身原是西雅图超音速，因试图于西雅图新建球场被拒后，索性将球队迁移至俄克拉荷马城并更名为俄克拉何马城雷霆，而NBA总部已和西雅图官员达成协议，保留超音速队名及队徽颜色，希望未来新增或有球队迁至西雅图时，能继续沿用。\n' +
    '印第安纳步行者、圣安东尼奥马刺、布鲁克林篮网（前纽约/新泽西篮网）和丹佛掘金，在1976年NBA兼并ABA的时候由ABA并入。\n' +
    '由于球队主场馆新奥尔良竞技馆受到卡特里娜飓风的严重破坏，新奥尔良黄蜂（现新奥尔良鹈鹕）于2005-06赛季及2006-07赛季的主场比赛是安排在俄克拉荷马市的福特中心进行[33]，且暂时更名为“新奥尔良/俄克拉荷马市黄蜂”。\n' +
    '夏洛特黄蜂于1988年成立，2002年牵至纽澳良改名新奥尔良黄蜂，2013年改名新奥尔良鹈鹕。\n' +
    '夏洛特山猫在2004年成立，在迈克尔·乔丹买下后，于2014年与纽澳良鹈鹕队达成协议，山猫队改名夏洛特黄蜂，并承接原属鹈鹕队的1988~2002年夏洛特黄蜂队史。\n' +
    '已经解散的球队\n' +
    '主条目：已解散的NBA球队列表\n' +
    '常规赛和全明星周末\n' +
    '主条目：NBA常规赛、NBA全明星周末和NBA赛季列表\n' +
    '夏季联赛（NBA Summer League）在选秀之后举行，一般在7月份，由新秀和3年以下球龄的球员参加，主要为考察新人而设，又称为“拉斯维加斯联赛”。9月末每队会开始夏季训练营，给球员热身，让教练评估球员表现，考察新人，确定赛季轮换12球员和3名备用球员的名单。之后队伍可以安排参加夏季联赛和季前赛。季前赛（Preseason）在每年的10月份举行，为常规赛前最后的热身赛。每支球队参加季前赛的球员名单基本与常规赛相同，不过主力上场的时间很少以避免受伤，主教练也借此机会来演练不同的阵容。夏季联赛和季前赛允许非NBA球队参加，而NBA还会把部分季前赛安排在海外进行。\n' +
    '\n' +
    '\n' +
    '波士顿凯尔特人与明尼苏达森林狼的比赛\n' +
    '每年10月的最后一周常规赛（Regular season）正式开始。在常规赛中，每支球队需要打满82场比赛，主客场各占一半，其中与同一赛区的4队要打4场，共16场；与同一个联盟（东部或西部）不同赛区的10队打3或4场，共36场；与不同联盟的球队打两场，共30场；一个赛季每支球队在自己的主场至少与其它29队进行一次交锋。2008年后，NBA是北美四大体育联盟唯一一个所有球队在常规赛全部碰面的联盟。常规赛的赛程紧凑，球队在每个星期有3到4场比赛，而且每个赛季都有不同程度的“背靠背作赛”（球队连续2天在不同的城市客场作战）、连续客场作赛等艰难赛程。除揭幕战外，圣诞节比赛也是常规赛的焦点赛事；NBA是北美四大体育联盟中唯一在圣诞节安排比赛的，通常是当前最具人气的球星之间的对垒，如2008-09赛季的圣诞节比赛由勒布朗·詹姆斯率领的克利夫兰骑士对阵德维恩·韦德领衔的迈阿密热火[34]。常规赛还设有每周东（西）部最有价值球员和每月东（西）部最有价值球员。\n' +
    '\n' +
    '次年2月，常规赛将会暂停1周来举行一年一度（1999年曾因劳资纠纷停办[35]）的NBA全明星赛（All-Star Game）。美国及加拿大当地球迷对全明星先发阵容进行投票，全世界球迷也可以通过互联网来投票。东西部各个位置得票最高的球员将获得首发，其余14名球员由各队教练投票选出，全明星教练则是由全明星赛两周前东西部成绩最好的球队教练担当（可以多任，但不能连任）。东西部获胜的一方表现最好的球员将获得全明星赛MVP。全明星赛前还有一系列的表演及活动来吸引球迷们的眼光，整个全明星周末的活动包括：\n' +
    '\n' +
    '新秀挑战赛，比赛的形式不定，历史上大多由应届新秀挑战二年级球员，也有应届新秀按东西部联盟对抗的情况，2012年则是由两位NBA名宿查尔斯·巴克利和奥尼尔在优秀的年轻球员中挑选各自属意的队员进行比赛。2015年改为NBA本土新秀对阵NBA外籍新秀。\n' +
    '技巧挑战赛，参赛者必须在最快的时间内完成运球，传球，投篮，上篮等一系列动作方能获胜，2015年改为两人同场对抗。\n' +
    '三分大赛，规定时间内在5个角度投中最多三分球者胜出，2015年调整为任意一个角度可以放5个加分球总得分由30分变成34分\n' +
    '扣篮大赛，参赛者尝试做出各种高难度、极具观赏性的扣篮动作，通常邀请历届扣篮大赛冠军作为评判，每人只有3次机会，否则，打出最低分30分\n' +
    '混合投篮赛，由一名现役NBA球员、一名现役WNBA球员和一名退役的NBA球星组成队伍，按要求在不同的投篮点投篮，完成最快组胜出\n' +
    '除此之外，在整个全明星周末期间，每天都有NBA嘉年华的演出。\n' +
    '\n' +
    '全明星周末后很快来到球员交易的最后期限，即赛季的第16个星期四。这一天之后，球队之间不能再交易球员。不过仍可解雇球员，或者跟自由球员签订十日合同[36]。\n' +
    '\n' +
    '四月份常规赛结束，紧接着进行季后赛。NBA官方会陆续颁发一些奖项来表扬常规赛表现出色的球员，以及评选最佳阵容，最佳防守阵容及最佳新秀阵容。\n' +
    '\n' +
    'NBA最有价值球员，是美国国家篮球协会从1955-1956年NBA赛季开始颁发的年度奖项，旨在表彰赛季中综合表现最优异的球员。\n' +
    'NBA最佳新秀，年度表现最好的新秀。\n' +
    'NBA最佳防守球员，年度最佳防守球员，多数由中锋获得。\n' +
    'NBA最佳第六人，年度最佳板凳球员，替补出场次数必需大于首发次数。\n' +
    'NBA进步最快球员，年度数据提升最多的球员。\n' +
    'NBA最佳教练，全联盟成绩最好的球队教练不一定能获此殊荣，一般由善于挖掘球队潜力，带领球队取得意想不到成绩的教练获得。\n' +
    'NBA最佳经理，由体育新闻杂志（Sporting News）颁发的非官方奖项，不过已得到广泛认可。\n' +
    'NBA体育精神奖，表扬公平竞赛的球员。\n' +
    '沃特·肯尼迪公民奖，表扬热心慈善公益活动的球员，由职业篮球作家协会颁发。\n' +
    '季后赛\n' +
    '主条目：NBA季后赛\n' +
    'NBA总冠军\n' +
    '主条目：NBA总决赛和NBA总冠军\n' +
    '队伍\t夺冠次数\t夺冠年份\n' +
    '波士顿凯尔特人\t17\t1957、1959-1966、1968-1969、 1974、1976、1981、1984、1986、2008\n' +
    '明尼阿波利斯/洛杉矶湖人\t17\t1949-1950、1952-1954、1972、1980、1982、1985、1987-1988、2000-2002、2009-2010、2020\n' +
    '费城/旧金山/金州勇士\t7\t1947、1956、1975、2015、2017-2018、2022\n' +
    '芝加哥公牛\t6\t1991-1993、1996-1998\n' +
    '达拉斯/得克萨斯矮树丛/圣安东尼奥马刺\t5\t1999、2003、2005、2007、2014\n' +
    '锡拉丘兹民族队/费城76人\t3\t1955、1967、1983\n' +
    '韦恩堡(左纳)/底特律活塞\t3\t1989-1990、2004\n' +
    '迈阿密热火\t3\t2006、2012-2013\n' +
    '纽约尼克斯\t2\t1970、1973\n' +
    '圣迭戈/休斯敦火箭\t2\t1994-1995\n' +
    '密尔沃基雄鹿\t2\t1971、2021\n' +
    '巴尔的摩子弹（已解散）*\t1\t1948\n' +
    '罗切斯特/辛辛那提皇家队/堪萨斯-奥马哈/堪萨斯/萨克拉门托国王\t1\t1951\n' +
    '三城黑鹰队/密尔瓦基/圣路易/亚特兰大鹰\t1\t1958\n' +
    '波特兰开拓者\t1\t1977\n' +
    '华盛顿子弹/奇才\t1\t1978\n' +
    '西雅图超音速/俄克拉何马城雷霆\t1\t1979\n' +
    '达拉斯独行侠\t1\t2011\n' +
    '克利夫兰骑士\t1\t2016\n' +
    '多伦多猛龙\t1\t2019\n' +
    '附注：\n' +
    '巴尔的摩子弹队是唯一一支已经解散、获得过NBA总冠军的球队，这里所指的是1947年成立的巴尔的摩子弹队，并非现行华盛顿奇才的前身巴尔的摩子弹队(1963-1973)。\n' +
    '详细冠军数据请参看NBA总冠军\n' +
    '劳资关系\n' +
    '参见：NBA劳资协议\n' +
    'NBA球员工会称作国家篮球球员协会（NBPA），由前波士顿凯尔特人球星鲍勃·库锡于1954年建立[35]，负责代表球员与球队老板进行谈判，并维护球员们的利益。工会执行主管是Michele Roberts，工会现任主席是来自波特兰开拓者的C·J·麦科勒姆。劳资协议（Collective Bargaining Agreement，简称CBA）是NBPA和NBA达成的一个合约，是所有球员合同的基础。\n' +
    '\n' +
    '1998年，由于NBPA拒绝NBA提出的将球员工资由占BRI的57%降到48%和设立硬工资帽的提议，NBA从7月1日起关闭球馆并停止一切商业活动，直到第二年的1月20日双方达成协议签订了新的CBA。这次长达7个月191天的停摆是NBA历史上最长的一次停止运作，1998-99赛季常规赛最终被压缩到50场，同时全明星周末亦停办；球员损失工资达到四亿美元，而球队及NBA联盟损失接近十亿美元[35]。\n' +
    '\n' +
    '而上一份劳资协议使用期限是2005-06赛季至2010-11赛季，2010-11赛季后双方在谈判过程中意见分歧很大，未能达成共识，因此造成停摆，使得2011-12赛季从82场被压缩到剩66场常规赛。\n' +
    '\n' +
    '最新的一份劳资协议是在2011年签订的，其中对奢侈税的征收变得更严厉，并采阶梯式上升，将在2014-15赛季实施。\n' +
    '\n' +
    '球员合同[36][37]\n' +
    '2007-08赛季工资限制[36]\n' +
    'NBA\n' +
    '球龄\t最低年薪\n' +
    '（美元）\t最高年薪\n' +
    '（美元）\n' +
    '0\t427,163\t13,041,250\n' +
    '1\t687,456\t13,041,250\n' +
    '2\t770,610\t13,041,250\n' +
    '3\t798,328\t13,041,250\n' +
    '4\t826,046\t13,041,250\n' +
    '5\t895,341\t13,041,250\n' +
    '6\t964,636\t13,041,250\n' +
    '7\t1,033,930\t15,649,500\n' +
    '8\t1,103,225\t15,649,500\n' +
    '9\t1,108,718\t15,649,500\n' +
    '10+\t1,219,590\t18,257,750\n' +
    '根据最新的劳资协议，自由球员与球队签订的合同最长年限为五年（使用拉里·伯德条款为六年），年薪涨幅最高为8%（使用拉里·伯德条款为10.5%）；年限超过四年（包括四年）的合同经过三个赛季后可以被延长，延长合同的第一年工资不得高于原合同最后一年的110.5%；合同里可以包含球队选项、球员选项以及球员提前终止合约选项中的其中一项或多项附加条款。劳资协议同时规定了球员工资的上下限。2007-08赛季在NBA效力十年以上的球员将至少可以得到1,219,590美元的年薪，而首次参加NBA的球员（包括新秀）的最低年薪是427,163美元；底薪每年上涨3.5%。球员可以得到的最高工资随着NBA球龄而不同，少于六年球龄为900万与工资帽的25%中的最大值，七到九年球龄为1100万与工资帽的30%中的最大值，十年以上为1400万与工资帽的35%中的最大值。同时NBA亦规定了球员最高工资不得少于上一年工资的105%，由于工资涨幅关系，球员可以拿到超过当年最高年薪上限的工资。如2007-08赛季全联盟薪水最高的凯文·加内特（波士顿凯尔特人）的工资是2200万美元，远远高于最高年薪上限的1838.8万美元[38]。\n' +
    '\n' +
    '第一轮新秀的新秀合同期限为四年（后两年可选择执行或放弃），球员在第二个赛季前可以选择执行第三年的合约或成为自由球员，如果执行了，在第三个赛季前还可以选择执行第四年的合约或成为自由球员。当新秀完成四年合同后，他将成为受限制自由球员。\n' +
    '\n' +
    '十日合同（10-day Contract）是赛季中后段球队为了应付由于伤病或其它原因缺乏人手的问题与自由球员签订的临时合约，期限为十天（或三场比赛，取较大值）。一支球队与一名球员在一个赛季内只能签订两次十日合同，如果第三次签约则必须把期限延长到赛季结束，同时球队的十日合同的数量不得超过伤病名单的人数。十日合同在每年1月5日后才允许签订。\n' +
    '\n' +
    '双向合同（Two-Way Contract）球队可以拥有最多两个双向合同球员。他们既可参与NBA比赛，亦可参与NBA G联盟赛事，但以G联盟为优先。每季最多可以参与45场NBA常规赛，但该球员不得参加季后赛。球队通常安排球双向合同球员前往姊妹球队训练及比赛，但是一些没G联盟球员则需与其他球队安排。。\n' +
    '\n' +
    '自由球员\n' +
    '自由球员（Free Agency）包括受限制和非受限制的，区别在于，当受限制自由球员（Restricted Free Agency）与新球队达成协议（新球队对球员只能提供邀请合同（Offer Sheet））的时候，如果球员原属球队在15天内开出同等价值的合同，那么将可以留住这名球员；非受限制自由球员则不受原属球队的任何约束。\n' +
    '\n' +
    '首轮新秀在完成四年的新秀合同后将自动成为受限制自由球员，而其他自由球员如果在NBA效力的时间不足三年的也是受限制的。不过，没有执行新秀合同第三或第四年选择条款的首轮新秀、或者被球队选中后放弃的新秀将成为非受限制自由球员。\n' +
    '\n' +
    '球队交易[36][37]\n' +
    '在NBA，工资上限以下的球队可以任意进行球员交换，不过鉴于NBA球队的总工资基本上都在工资帽以上，球队在交易过程中使用最多的就是交易球员特例（Traded Player Exception），另外还有底薪球员特例和伤残球员特例。按照交易球员特例，球队在即时交易（Simultaneous Trade）中转入的总年薪不得高于转出总年薪的125%+10万，可以涉及多名球员；而球队在非即时交易（Non-simultaneous Trade）中只能送出一名球员（交易筹码甚至可以不是球员），交易出现的合同差额将作为一个“交易补偿”，由转出高合同球员的球队获得，这个“补偿”可以用到同年或下一年的交易中，不过通常是跟选秀权搭配来使用，因为选秀权在交换过程中工资价值为零。NBA还规定连续两年的首轮选秀权不能同时送出。球员在交易过程中最多可以使用300万现金，但是现金的工资价值同样为零。\n' +
    '\n' +
    '球队工资帽及豪华税\n' +
    '参见：NBA工资帽\n' +
    '特殊条款\n' +
    '主条目：NBA特殊条款\n' +
    '特殊条款是针对工资帽而制定的特例。包括有拉里·伯德条款、中产阶级条款、一百万特例、底薪特例等，总工资超过工资上限的球队可以使用这些条款来与自由球员签约。不过球队对这些条款的运用也有限制，如中产阶级条款每个赛季只能对一名球员使用，而一百万特例不能连续两个赛季采用。\n' +
    '\n' +
    '球员和教练\n' +
    'NBA球员大多数来自美国大学篮球联赛（包括NCAA、NAIA、NJCAA等），当然也有直接从高中加盟NBA的，不过新的劳资协议对高中球员作了限制，要求必需在高中毕业一年后才能参加选秀[36]。近年来随着NBA在国际市场的不断开拓，参加NBA的国际球员也日益增多；海外球员一般来自各国的篮球联赛，他们可以参加选秀或者直接跟球队签约。球员比例方面，黑人球员是NBA的主导，一直保持在70%以上。\n' +
    '\n' +
    '\n' +
    'NBA教练菲尔·杰克逊在与裁判争论\n' +
    'NBA球衣及服装由耐克统一赞助，不过球鞋是一个例外——球员可以拥有自己的球鞋赞助商。另外NBA制定有球员服装令（Player Dress Code）[39]，球员在参加联盟及球队的非比赛及训练活动中必须穿“商务休闲装”。球员在比赛场上的不文明行为（辱骂、打人等）都会受到NBA的罚款甚至禁赛处罚；NBA还规定了球员在比赛期间不得冲上看台。\n' +
    '\n' +
    '与球员不同，NBA主教练尽管没有受到服装令的约束，但他们在每场比赛都穿上整齐的西服在场边指挥，颇显绅士风度。NBA对主教练的一条重要规定是，在比赛进行过程中主教练不得离开替补席周围28码的范围，或越过球场边线[40]，包括和裁判争论的时候，否则就会被判技术犯规。\n' +
    '\n' +
    'NBA选秀\n' +
    '主条目：NBA选秀\n' +
    'NBA选秀是一年一度的盛事，于每年的6月底在纽约的麦迪逊花园广场举行。参加选秀的球员必需年满19岁，美国本土球员还必需满足高中毕业至少一年的要求。（2006年选秀前可以允许高中生参与选秀，因此德怀特·霍华德成为最后一个高中新秀状元）。至2018/19赛季，仅有10名外籍球员获选状元，其中包括中国的姚明（科尔-安东尼·唐斯、阿基姆·奥拉朱旺、蒂姆·邓肯、凯里·欧文均拥有美国籍），他和意大利球员安德里亚·巴格纳尼（2006年）是仅有的两位在选秀之前没有经历过任何美国篮球体系训练的状元。\n' +
    '\n' +
    '理论上所有球队每年都会分得两个选秀权，但实际上由于选秀权可以用来交换，往往会造成有些球队在某年选秀大会上成为看客。\n' +
    '\n' +
    '选秀大会分两轮，每轮30个顺位。第二轮（31～60顺位）是直接按照球队在常规赛的成绩的倒序来排列的。第一轮后十六个顺位（15～30）是进入季后赛的十六支球队按照常规赛的成绩的倒序来排定；1～14顺位(又称为乐透区)则属于未能进入季后赛的十四支球队，不过并非是直接按照常规赛成绩来排列，而是通过抽签决定顺位的归属。也就是说，没有进入季后赛的十四支球队都有机会获得前三号选秀权，只是成绩较差的球队比较好者赢取的几率大。根据规则，常规赛成绩最差的球队将有25%的几率获得头号选秀权（即所谓的状元签），成绩倒数第二的球队有19.9%的几率，而十四队中成绩最好的球队获取的几率仅有0.5%[41]。前三号的选秀权的抽签通常在每年的5月进行。\n' +
    '\n' +
    '球队在选中新秀之后可以选择和他签约，亦可以放弃或者直接交换出去，如果新秀遭到放弃，他将成为自由球员（非受限制），如果是交易的话还没获得合同的新秀与选秀权一样是工资价值为零的。球队与新秀签约后，60天内不能把他交易出去。如果新秀不愿意与选中他的球队签约，而球队又不同意交易或放弃他的话，该新秀在一年内将不能和其它NBA球队签约，挑选他的球队保留有一年的签约权；该新秀还可以参加下一年的选秀。\n' +
    '\n' +
    '篮球名人堂\n' +
    'NBA球员可以获得的最高荣誉就是入选篮球名人堂，全称奈史密斯篮球名人纪念堂（Naismith Memorial Basketball Hall of Fame）。不过名人堂并非专门为NBA而设，而是表彰全世界为篮球事业做出卓越贡献的个人和团队，包括篮球运动员、篮球教练、篮球裁判、篮球队伍以及在其它方面为篮球奉献的人。2007年入选名人堂的NBA名人是曾10次带领球队夺得NBA总冠军、前任洛杉矶湖人队及芝加哥公牛队主教练菲尔·杰克逊[42]。\n' +
    '\n' +
    '场地规格\n' +
    'NBA的比赛场地规格为：长94呎（28.65米），宽50呎（15.24米）。\n' +
    '\n' +
    'NBA的篮筐上缘离地板距离为：10呎（3.05米）；篮筐直径为：18吋（46公分），篮网长度为：16吋（41公分）。\n' +
    '\n' +
    'NBA的篮板大小为：长6呎（1.83米），宽3.5呎（1.07米），厚3.5吋（3.81公分）；篮板上缘离地板13呎（3.96米）；篮板的内部矩形长24吋（61公分），宽18吋（46公分）。\n' +
    '\n' +
    'NBA的三分线离篮筐距离为：弧顶区域23呎9吋（7.24米），底角区域为22呎（6.71米）。\n' +
    '\n' +
    'NBA的比赛用球周长为：29.5吋（75公分），重量为：22盎司（624公克）。\n' +
    '\n' +
    'NBA领导人[43]\n' +
    '莫里斯·波杜夫（1946－63年，主席），NBA（BAA）第一任主席。出生于俄罗斯的波杜夫是一名律师，同时也是一名精明的商人和出色的谈判专家。1946年，他与一些冰球队的老板商议并成立了美国篮球协会（BAA），被推选为主席；同时他还是当时美国冰球联盟（AHL）的主席。1949年，波杜夫成功说服竞争对手国家篮球联盟（NBL），促成两个篮球组织的合并，建立了新的国家篮球协会（NBA）；1954年，波杜夫推出了一项足以改变篮球历史的措施——24秒钟装置，为NBA后来的成功埋下了坚实的基础。NBA为表扬波杜夫的贡献，把最有价值球员奖杯命名为莫里斯·波杜夫杯[11]。\n' +
    '詹姆斯·沃尔特·肯尼迪（1963－67年，主席，1967－75年，总裁）,1963年上任，是NBA第一位公选的领导人。在成为NBA主席之前肯尼迪还担任过康涅狄格州斯坦福德的市长。肯尼迪在任期间得到NBA老板的全力支持，1971年他被赋予极大的权力，成为当时全美最有统治力的职业体育联盟领导人；而他也极力扩充NBA的规模，在他离任的时候NBA球队已经由当初的9支扩大到18支。以他命名的沃尔特·肯尼迪公民奖是用来表扬热心慈善公益活动的球员或教练。\n' +
    '拉里·奥布赖恩（1975－84年，总裁），NBA第三任总裁。与其他三位总裁乃至所有体育领导人相比，奥布莱恩拥有极不寻常的背景，他曾担任美国民主党主席和美国邮政局主席，并长期作为已故美国总统约翰·肯尼迪的顾问。奥布莱恩上任后的第一件大事就是成功兼并ABA（美国篮球协会），解决了由于两联盟的恶性竞争而导致的工资飞涨、票房下降等问题，当中包括非常棘手的“奥斯卡·罗伯特森球衣”事件。1983年，奥布莱恩与NBA球员工会达成的新的劳资协议，被认为是NBA联盟发展的蓝图和基础；而他对NBA规则的改革的最大贡献在于1979年设立的三分线。奥布莱恩离任后不久，NBA把总冠军奖杯命名为拉里·奥布赖恩冠军奖杯[44]。\n' +
    '大卫·斯特恩（1984－2014年，总裁），1984年上任，是目前在位时间最长的NBA总裁。斯特恩把NBA的商业利益最大化，并成功把NBA推向全球市场，使NBA成为一个具有国际性影响力的体育联盟。\n' +
    '萧华（2014年至今，总裁），2014年上任，2014年2月1日斯特恩卸任NBA总裁，席尔瓦将接替这项职务。\n' +
    '电视转播\n' +
    '美国广播公司（ABC）、特纳电视网（TNT）以及ESPN是现今NBA在美国本土的电视合作伙伴，他们于2002年与NBA签订了为期6年价值46亿美元的合同[45]，2007年又将合约以8年74亿美元的价格延长至2016年。2014年10月6日, NBA宣布与ESPN、美国广播公司（ABC）以及特纳电视网（TNT）签订价值达到9年240亿美元(27亿/年)的续约合同，新合同从2016-17赛季开始生效一直延续到2024-25赛季，[46]这也使得NBA拥有世界上第二昂贵的电视转播合同, 仅次于NFL并同英超新电视转播合同（2016-17赛季到2018-19赛季）的年度价格相当。[47]\n' +
    '\n' +
    '联盟年度日历当中最重要的比赛包括开幕赛，圣诞节比赛，NBA全明星周末和总决赛。对于那些全国直播的常规赛，TNT安排在周四晚上，ESPN安排在周三和周五晚上, ABC的首两场直播会安排在圣诞节, 之后会从一月份开始在周六黄金时段（2015-16赛季开始）和周日下午进行常规性播出。季后赛所有比赛都会全国直播, 在前两轮ABC通常会安排在周末下午（外加1-2场周六黄金时段），ESPN通常安排在周四和周五，TNT转播剩余的比赛, 另外NBA TV也有少量直播。TNT和ESPN每年轮流转播东西部决赛，比如2016年东部决赛为ESPN，西部决赛为TNT，而2017年东部决赛变成TNT，西部决赛为ESPN。总决赛全部由ABC直播（ESPN制作）, 国际转播中不会显示ABC, 因为其使用的是NBA TV International的信号。三家电视网播出的NBA相关节目包括赛后节目Inside the NBA（TNT，每周四晚播出，查尔斯·巴克利、肯尼·史密斯担任嘉宾），赛前节目NBA Countdown（ABC和ESPN），NBA Wednsday（ESPN）、NBA Friday（ESPN）、NBA Saturday Primetime（ABC）、NBA Sunday Showcase（ABC）和NBATV的众多节目等。\n' +
    '\n' +
    '30支NBA球队各有地区收费电视网络合作伙伴，可在季前热身赛，常规赛82场比赛以及季后赛第一轮替当地观众直播赛事，只要不是由美国广播公司所直播赛赛事（不包括位处加拿大的多伦多猛龙），地区电视网络可以选择是否直播ESPN或TNT全国直播之赛事。\n' +
    '\n' +
    'NBA拥有自己的电视台NBA TV和NBA TV Canada, 另外加拿大的Sportsnet和TSN也拥有NBA常规赛的转播权，另外在市场外体育套餐方面（Out-of-market sports package）有NBA League Pass和NBA League Pass International。\n' +
    '\n' +
    '中国大陆可通过腾讯视频（全场次直播，大部分场次付费）、咪咕视频（全场次付费）在线观看NBA赛事；电视端则由央视和多家地方台体育频道（部分场次，免费）以及SiTV劲爆体育频道（部分场次，付费）转播；IPTV端由百视通提供转播。香港地区现时由ViuTV播放。\n' +
    '\n' +
    '中华民国（台湾）可透过纬来体育台（第四台）、Eleven Sports（第四台）、ELTA爱尔达电视台（中华电信MOD）进行观看。在移动设备部分以及网络直播也有Line today提供部分场次免费转播。\n' +
    '\n' +
    'NBA相关的游戏及娱乐\n' +
    'NBA很多球队都拥有自己的吉祥物，吉祥物一般出自队名或者当地的珍稀动物。每当比赛暂停时间，吉祥物就会出来场地中央表演，表演的花样很多，包括超高难度的花式灌篮（当然有弹簧垫助跳），另外还有美女啦啦队的表演。\n' +
    '\n' +
    'EA公司开发的NBA Live以及世嘉开发（后转为Take-Two）的NBA 2K是目前较受欢迎的NBA游戏，不过NBA 2K直到2K9方才推出PC版,而到2K12时则推出了手机版。 另外还有NBA篮球经理、NBA Street等。\n' +
    '\n' +
    '争议\n' +
    '参见：反对逃犯条例修订草案运动、对于中国共产党介入反对逃犯条例修订草案运动的质疑和达雷尔·莫雷涉港言论争议\n' +
    '2019年10月5日，NBA休斯敦火箭队时任总经理达雷尔·莫雷在Twitter发表“为自由而战，与香港同在（Fight for freedom, Stand with Hong Kong）”的图文，被解读为声援反送中运动。中国中央电视台体育频道于10月6日指控前述言论“不当”，当日起暂停涉及火箭队的赛事转播等合作交流，10月8日起暂停NBA赛事转播[48]。中国篮球协会、腾讯体育、浦发银行等宣布暂停或中止与休斯敦火箭队相关合作。[49][50]火箭队周边产品从中国大陆各电商平台下架。[51][52]\n' +
    '\n' +
    '10月7日，NBA首席传播官声明莫雷的观点“深深冒犯”、“令人遗憾”，支持个人表达意见，而在中文声明中称对“莫雷发表的不当言论极其失望”，严重伤害中国球迷的感情。美国两大党政治人物和传媒就此批评NBA没有维护民主价值，为商业利益向北京低头。[53][54]10月7日及8日，NBA总裁萧华表示支持言论自由[55]，“包括言论自由在内的这些价值观从联盟成立之初就存在”，向中国大陆粉丝道歉与支持言论自由并不冲突[52]。10月18日，萧华表示中国大陆政府曾要求他开除莫雷，被他断然拒绝，中国大陆外交部则否认此事。[56]10月24日，美国副总统迈克·彭斯在演说中论及“明星球员和经理以往都能够自由地批评美国，但是遇到中国人民的权利时，却默不作声，靠拢中国共产党而压抑言论自由”，批评NBA“像是被极权政府拥有的分公司”，“有意忽视侵犯人权的行为”。[57]\n' +
    '\n' +
    '2020年10月10日，中国中央电视台复播NBA赛事，赞扬NBA持续表达善意和支援中国大陆抗击2019冠状病毒病等努力。[58][59]10月16日莫雷离职火箭队，中央电视台提及“付出代价”，寄望莫雷“一路走好”。[60]11月2日，莫雷成为费城76人队篮球事务总裁，在受访时指出，事件爆发后曾担心家人安危，也一度认为自己的NBA生涯就此结束，但他并不后悔支持香港示威者的决定。[61]'
});

const originalData = {
  array: cloneDeep(testData.array),
  text: testData.text
}

const searchData = reactive({
  array: '',
  text: ''
});

function handleArray(event) {
  searchData.array = event.target.value;
  if (searchData.array) {
    const resultArray = [];
    forEach(originalData.array, item => {
      const searchResult = getHighlightSearch(item.value, searchData.array);
      if (searchResult.isMatch) {
        resultArray.push({
          ...item,
          value: searchResult.highlightStr
        })
      }
    })
    testData.array = resultArray;
  } else {
    testData.array = originalData.array;
  }
}

function handleText(event) {
  searchData.text = event.target.value;
  if (trim(searchData.text)) {
    testData.text = getHighlightKeyword(originalData.text, searchData.text);
  } else {
    testData.text = originalData.text;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", null, [
        _createElementVNode("input", {
          onInput: handleArray,
          value: searchData.array
        }, null, 40, _hoisted_4)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(testData.array, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.key,
              class: "search_content_list",
              innerHTML: item.value
            }, null, 8, _hoisted_5))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", null, [
        _createElementVNode("input", {
          onInput: handleText,
          value: searchData.text
        }, null, 40, _hoisted_8)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", {
          innerHTML: testData.text
        }, null, 8, _hoisted_10)
      ])
    ])
  ]))
}
}

})